

import React from 'react';
import Image from '@/components/image';
import styles from './index.module.css';
import imageIcon from '@/public/assets/images/20241009-152443.png';

type ImageItemProps = {
    id: number;
    title: string;
    image: string;
    index?: number;
    onClick?: (id: number, index?: number) => void;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'id' | 'onClick'>;   // 继承div的属性
/**
 * @description: 照片集单项Item样式
 * @param {ImageItemProps} param1
 * @return {*}
 */
export default function ImageItem({ id, index, title, image, onClick }: ImageItemProps) {
    return (
        <div
            key={id}
            className={styles['images-item']}
            onClick={() => {
                onClick && onClick(id, index);
            }}
        >
            <Image src={imageIcon} alt='' className={styles['icon']} />
            <img
                className={styles['images-item-img']}
                src={image}
                alt=""
            />
            <div className={styles['images-item-title']}>
                {title}
            </div>
        </div>
    )

}